import {Routes} from '@angular/router';
import {LoginIndexComponent} from "./pages/login/login-index.component";
import {SessionService} from './services/session.service.js';
import {AppointmentsComponent} from './pages/appointments/appointments.component.js';
import {AppointmentsService} from './services/appointments/appointments.service.js';
import {AppointmentComponent} from './pages/appointments/appointment/appointment.component.js';
import {OrganizationsComponent} from './pages/organizations/organizations.component.js';
import {OrganizationsService} from './services/organizations/organizations.service.js';
import {OrganizationComponent} from './pages/organizations/organization/organization.component.js';
import {UsersService} from './services/users/user.service.js';
import {UsersComponent} from './pages/users/users.component.js';
import {UserComponent} from './pages/users/user/user.component.js';
import {PatientsComponent} from "./pages/patients/patients.component";
import {PatientsService} from "./services/patients/patients-service";
import {PatientComponent} from "./pages/patients/patient/patient.component";
import {ToolsComponent} from "./pages/tools/tools.component";

export const routes:Routes = [
	{
		path: "login",
		component: LoginIndexComponent
	},
	{
		path: "appointments",
		title: "Appointments",
		canActivate: [SessionService.canActivateLoggedIn],
		children: [
			{
				path: "",
				title: "Appointments",
				component: AppointmentsComponent,
				resolve: {appointments: AppointmentsService.resolveAppointments}
			},
			{
				path: ":id",
				title: "Appointment",
				component: AppointmentComponent,
				resolve: {appointment: AppointmentsService.resolveAppointmentDetail}

			}
		]
	},
	{
		path: "organizations",
		title: "Organizations",
		canActivate: [SessionService.canActivateLoggedIn],
		children: [
			{
				path: "",
				title: "Organizations",
				component: OrganizationsComponent,
				resolve: {organizations: OrganizationsService.resolveOrganizations}
			},
			{
				path: ":id",
				title: "Organization",
				component: OrganizationComponent,
				resolve: {organization: OrganizationsService.resolveOrganizationDetail}

			}
		]
	},
	{
		path: "users",
		title: "Users",
		canActivate: [SessionService.canActivateLoggedIn],
		children: [
			{
				path: "",
				title: "Users",
				component: UsersComponent,
				resolve: {users: UsersService.resolveUsers}
			},
			{
				path: ":id",
				title: "User",
				component: UserComponent,
				resolve: {users: UsersService.resolveUserDetail}

			}
		]
	}, {
		path: "patients",
		title: "Patients",
		canActivate: [SessionService.canActivateLoggedIn],
		children: [
			{
				path: "",
				title: "Patients",
				component: PatientsComponent,
				resolve: {patients: PatientsService.resolvePatients}
			},
			{
				path: ":id",
				title: "Patient",
				component: PatientComponent,
				resolve: {users: PatientsService.resolvePatientDetail}

			}
		]
	}, {
		path: "tools",
		title: "Tools",
		canActivate: [SessionService.canActivateLoggedIn],
		children: [
			{
				path: "",
				title: "Tools",
				component: ToolsComponent
			}
		]
	},

	{path: '**', redirectTo: 'appointments'}
];
